import React from 'react';
import { Form } from "@/components/ui/form";

import { useTerraceForm } from '@/hooks/useTerraceForm';
import { useFormValidation } from '@/hooks/useFormValidation';
import { useGoogleMapsProcessing } from './hooks/useGoogleMapsProcessing';
import { useTerraceSubmission } from './hooks/useTerraceSubmission';
import FormHeader from './form-sections/FormHeader';
import FormInputSection from './form-sections/FormInputSection';
import TerraceBasicInfo from './TerraceBasicInfo';
import TerraceContact from './TerraceContact';
import OpeningHoursPerDay from './OpeningHoursPerDay';
import TerraceDescription from './TerraceDescription';
import TerraceFeatures from './TerraceFeatures';
import SubmitterNameField from './SubmitterNameField';
import SubmissionFormFooter from './SubmissionFormFooter';
import PhotoPreview from './PhotoPreview';

const SubmissionForm = () => {
  // Use centralized form management
  const { form, populateFromApiData, resetToDefaults } = useTerraceForm();
  const { validateRequiredFields, hasValidationErrors } = useFormValidation(form);

  const {
    isProcessingLink,
    setIsProcessingLink,
    isAiFilled,
    extractedCoordinates,
    extractedPlaceId,
    extractedPlaceName,
    originalMapsUrl,          // <-- NEW
    handleLinkProcessed,
    handleResetForm
  } = useGoogleMapsProcessing(form, populateFromApiData, resetToDefaults);

  const { onSubmit } = useTerraceSubmission(
    extractedCoordinates, 
    null, // No photo selection for users
    extractedPlaceId,
    extractedPlaceName,
    originalMapsUrl        // <-- NEW
  );

  // Enhanced form submission with validation
  const handleFormSubmit = form.handleSubmit((data) => {
    if (!validateRequiredFields()) {
      console.error("Required fields are missing");
      return;
    }
    if (hasValidationErrors()) {
      console.error("Form has validation errors");
      return;
    }
    onSubmit(data);
  });

  return (
    <div className="max-w-2xl mx-auto">
      <FormHeader />
      
      <div className="space-y-6 mt-6">
        <FormInputSection
          isProcessingLink={isProcessingLink}
          setIsProcessingLink={setIsProcessingLink}
          onLinkProcessed={handleLinkProcessed}
          onReset={handleResetForm}
          isAiFilled={isAiFilled}
        />

        {isAiFilled && (
          <Form {...form}>
            <form onSubmit={handleFormSubmit} className="space-y-6">
              <TerraceBasicInfo form={form} />
              <TerraceContact form={form} />
              <OpeningHoursPerDay form={form} />
              <TerraceDescription form={form} />
              <TerraceFeatures form={form} />
              
              {/* Show photo preview if available */}
              {form.watch('photo_url') && (
                <PhotoPreview photoUrl={form.watch('photo_url')} />
              )}
              
              <SubmitterNameField form={form} />
              <SubmissionFormFooter />
            </form>
          </Form>
        )}
      </div>
    </div>
  );
};

export default SubmissionForm;
